{
  "privacyPolicy": {
    "text": "プライバシーポリシー | JIZAIPAD"
  },
  "view": {
    "title": "プライバシーポリシー",
    "text": "個人情報の定義",
    "text2": "本プライバシーポリシーにおいて、個人情報とは、個人情報保護法第2条第1項により定義され た個人情報を意味するものとします。",
    "text3": "当社が本人より直接取得する個人情報の利用目的",
    "text4": "当社は、本人より直接取得する以下の種類の個人情報について、それぞれ所定の利用目的で利用します。",
    "li": "当社サービスの提供のため。ここには、お客様がサーバに事前に登録した顔画像と、当社が提供するアプリケーションにより認識した顔画像の照合による本人認証を含みます",
    "li2": "当社サービスに関するご案内、お問い合わせ等への対応のため。お問い合わせ内容によっては、第9項に定める第三者提供にかかる同意を取得した上で、ハードウェアメーカにお問い合わせ内容を提供した上で対応することがあります",
    "li3": "当社の商品、サービス等のご案内のため",
    "li4": "当社サービスに関する当社の規約、ポリシー、その他お客様との合意等（以下「規約等」といいます。）に違反する行為に対する対応のため",
    "li5": "当社サービスに関する規約等の変更などを通知するため",
    "li6": "当社のサービスの改善、新サービスの開発等に役立てるため",
    "li7": "当社のサービスに関連して、個人に関する情報に該当しない形式に加工した統計データを作成するため",
    "li8": "当社のサービスに関連して、広告主、情報提供元、サービス提供元などに、どのような広告や情報、サービスなどを掲載または提供することが最適かつ効果的であるかを分析して提供することを目的として、広告配信事業者へ提供するため",
    "li9": "その他、上記利用目的に付随する目的のため",
    "text5": "映像データの取扱い",
    "text6": "当社の提供するカメラ等の機器を通じて記録された映像データの取扱いについては、当社の サービスを利用するお客様が必要に応じて通知又は公表する利用目的をご参照ください。 当社は、当社のサービスの改善、新サービスの開発等に役立てるために映像データを利用する ことがありますが、規約等で認められた範囲でのみ映像データに含まれる個人情報を利用する ものとし、本プライバシーポリシー又は規約等により許容される場合を除き、特定の個人を識別 できる情報として第三者に開示することはございません。",
    "text7": "個人情報利用目的の変更",
    "text8": "当社は、個人情報の利用目的を相当の関連性を有すると合理的に認められる範囲内において 変更することがあり、変更した場合には本人に通知又は公表します。",
    "text9": "個人情報利用の制限",
    "text10": "当社は、本人の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取り扱いませ ん。但し、次の場合を含め、個人情報保護法その他の法令により許容される場合はこの限りで はありません。",
    "li10": "法令に基づく場合（捜査機関からの令状等に基づく捜査を含みます）",
    "li11": "人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき",
    "li12": "公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき",
    "li13": "国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき",
    "li14": "学術研究機関等に個人データを提供する場合であって、当該学術研究機関等が当該個人データを学術研究目的で取り扱う必要があるとき。",
    "text11": "個人情報の適正な取得",
    "text12": "当社は、適正に個人情報を取得し、偽りその他不正の手段により取得しません。",
    "text13": "個人情報の保存期間",
    "text14": "当社は、法令で別段の定めがある場合を除き、利用目的に必要な範囲内で個人情報の保存期 間を定め（お客様がサーバに事前に登録した顔画像と、当社が提供するアプリケーションにより 認識した顔画像の照合による本人認証が行われる場合における顔画像については6か月、その他は必要に応じ定めます）、保存期間経過後又は利用目的達成後は個人情報を遅滞なく消去します。",
    "text15": "個人情報の安全管理",
    "text16": "当社は、個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理 が図られるよう、当社の従業員に対し、必要かつ適切な監督を行います。また、当社は、個人情 報の取扱いの全部又は一部を委託する場合は、委託先において個人情報の安全管理が図ら れるよう、必要かつ適切な監督を行います。",
    "text17": "第三者提供",
    "text18": "当社は、 本プライバシーポリシーに別途定める場合を除き、 あらかじめ本人の同意を得ない で、個人情報を第三者に提供しません。",
    "li15": "当該第三者が学術研究機関等である場合であって、当該第三者が当該個人データを学術研究目的で取り扱う必要があるとき。",
    "li16": "また、個人情報保護法その他の法令に基づき、以下の場合は第三者提供とは扱いません。",
    "li17": "当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託する場合",
    "li18": "合併その他の事由による事業の承継に伴って個人情報が提供される場合",
    "li19": "特定の者との間で共同して利用される個人データが当該特定の者に提供される場合であって、その旨並びに共同して利用される個人データの項目、共同して利用する者の範囲、利用する者の利用目的並びに当該個人データの管理について責任を有する者の氏名又は名称及び住所並びに法人にあっては、その代表者の氏名について、あらかじめ、本人に通知し、又は本人が容易に知り得る状態に置いているとき。",
    "text19": "広告配信事業者等への提供",
    "text20": "当社は、第2項第8号に定める目的のために、お客様の個人情報を外国の広告配信事業者 等に第三者提供する場合があります。各事業者の所在国および当該外国における個人情報の 保護に関する制度についての情報は、以下に記載する内容およびそれぞれのリンク先をご覧ください。なお、提供先の各外国事業者は、OECDプライバシーガイドライン8原則に対応する措置をすべて講じています。また、お客様がサイト訪問履歴情報の蓄積をご希望されない場合は、オプトアウトの設定をお願いします。",
    "text21": "アメリカ合衆国 (カリフォルニア州)",
    "text22": "個人情報の開示",
    "text23": "当社は、個人情報保護法の定めに基づき個人情報の開示を求められたときは、本人からのご 請求であることを確認の上で、本人に対し、遅滞なく開示を行います（当該個人情報が存在しな いときにはその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が開 示の義務を負わない場合は、この限りではありません。［なお、個人情報の開示につきまして は、当社所定の手数料を頂戴しておりますので、あらかじめ御了承ください。］",
    "text24": "個人情報の訂正等",
    "text25": "当社は、個人情報が真実でないという理由によって、個人情報保護法の定めに基づきその内容 の訂正、追加又は削除（以下「訂正等」といいます。）を求められた場合には、本人からのご請求であることを確認の上で、利用目的の達成に必要な範囲内において、遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正等を行い、その旨を本人に通知します（訂正等を行わない旨の決定をしたときは、本人に対しその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が訂正等の義務を負わない場合は、この限りではありません。",
    "text26": "個人情報の利用停止等",
    "text27": "当社は、個人情報があらかじめ公表された利用目的の範囲を超えて取り扱われているという理 由又は偽りその他不正の手段により取得されたものであるという理由により、個人情報保護法の定めに基づきその利用の停止又は消去（以下「利用停止等」といいます。）を求められた場合において、そのご請求に理由があることが判明した場合には、本人からのご請求であることを確認の上で、遅滞なく個人情報の利用停止等を行い、その旨を本人に通知します。但し、個人情報保護法その他の法令により、当社が利用停止等の義務を負わない場合は、この限りではありません。",
    "text28": "Cookie（クッキー）その他の技術の利用",
    "text29": "当社のサービスは、Cookie及びこれに類する技術を利用しており、その結果IPアドレス等のお 客様情報の一部が、他社（e.g.Google社）に収集される可能性があります。",
    "text30": "また、当サイトでは、Googleが提供するアクセス解析ツール「Googleアナリティクス」を利用しています。Googleが、当社又はGoogleの設定するcookieをもとにして、利用者の閲覧履歴を収集し、分析した結果を、当社が受け取り、当社がその結果を利用者の利用状況の把握や、当社のサービスに利用する場合があります。 GoogleによるGoogleアナリティクスにおけるデータの取扱いについては、以下の同社のサイトをご覧ください。",
    "text31": "Google アナリティクス 利用規約",
    "text32": "Google プライバシーポリシー",
    "text33": "「Googleのサービスを使用するサイトやアプリから収集した情報のGoogleによる使用」",
    "text34": "お問い合わせ",
    "text35": "開示等のお申出、ご意見、ご質問、苦情のお申出その他個人情報の取扱いに関するお問い合 わせは、下記の窓口までお願いいたします。 株式会社ジザイエ E-mail：jizaipad_support@jizaie.co.jp",
    "text36": "2025年9月29日改定",
    "text37": "2023年9月13日制定"
  }
}
